// source: acompanha/tutorial_videos/v1/tutorial_videos.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.TutorialVideo', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest', null, global);
goog.exportSymbol('proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.tutorial_videos.v1.TutorialVideo.repeatedFields_, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.TutorialVideo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.TutorialVideo.displayName = 'proto.acompanha.tutorial_videos.v1.TutorialVideo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.displayName = 'proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.displayName = 'proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.displayName = 'proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.displayName = 'proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.displayName = 'proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.displayName = 'proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.displayName = 'proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.displayName = 'proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.displayName = 'proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.displayName = 'proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.displayName = 'proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.TutorialVideo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
desktopUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
mobileUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
section: jspb.Message.getFieldWithDefault(msg, 6, ""),
pageKeysList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
sortOrder: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.TutorialVideo;
  return proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.TutorialVideo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesktopUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addPageKeys(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.TutorialVideo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDesktopUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMobileUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPageKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string desktop_url = 4;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getDesktopUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setDesktopUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string mobile_url = 5;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getMobileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setMobileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string section = 6;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string page_keys = 7;
 * @return {!Array<string>}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getPageKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setPageKeysList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.addPageKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.clearPageKeysList = function() {
  return this.setPageKeysList([]);
};


/**
 * optional int32 sort_order = 8;
 * @return {number}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
*/
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
*/
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo} returns this
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.tutorial_videos.v1.TutorialVideo.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pageKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
section: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest;
  return proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string page_key = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.prototype.getPageKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.prototype.setPageKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string section = 2;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse;
  return proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.tutorial_videos.v1.TutorialVideo;
      reader.readMessage(value,proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TutorialVideo items = 1;
 * @return {!Array<!proto.acompanha.tutorial_videos.v1.TutorialVideo>}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.tutorial_videos.v1.TutorialVideo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.tutorial_videos.v1.TutorialVideo, 1));
};


/**
 * @param {!Array<!proto.acompanha.tutorial_videos.v1.TutorialVideo>} value
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse} returns this
*/
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.TutorialVideo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.tutorial_videos.v1.TutorialVideo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse} returns this
 */
proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest;
  return proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse;
  return proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.tutorial_videos.v1.TutorialVideo;
      reader.readMessage(value,proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter
    );
  }
};


/**
 * optional TutorialVideo data = 1;
 * @return {?proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.tutorial_videos.v1.TutorialVideo} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.tutorial_videos.v1.TutorialVideo, 1));
};


/**
 * @param {?proto.acompanha.tutorial_videos.v1.TutorialVideo|undefined} value
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse} returns this
*/
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse} returns this
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
desktopUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
mobileUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
section: jspb.Message.getFieldWithDefault(msg, 4, ""),
pageKeysList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest;
  return proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesktopUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPageKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDesktopUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMobileUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPageKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string desktop_url = 2;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.getDesktopUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.setDesktopUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mobile_url = 3;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.getMobileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.setMobileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string section = 4;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string page_keys = 5;
 * @return {!Array<string>}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.getPageKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.setPageKeysList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.addPageKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest.prototype.clearPageKeysList = function() {
  return this.setPageKeysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse;
  return proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.tutorial_videos.v1.TutorialVideo;
      reader.readMessage(value,proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter
    );
  }
};


/**
 * optional TutorialVideo data = 1;
 * @return {?proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.tutorial_videos.v1.TutorialVideo} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.tutorial_videos.v1.TutorialVideo, 1));
};


/**
 * @param {?proto.acompanha.tutorial_videos.v1.TutorialVideo|undefined} value
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse} returns this
*/
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse} returns this
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
desktopUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
mobileUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
section: jspb.Message.getFieldWithDefault(msg, 5, ""),
pageKeysList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest;
  return proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesktopUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPageKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDesktopUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMobileUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPageKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string desktop_url = 3;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.getDesktopUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.setDesktopUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mobile_url = 4;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.getMobileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.setMobileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string section = 5;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string page_keys = 6;
 * @return {!Array<string>}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.getPageKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.setPageKeysList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.addPageKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest.prototype.clearPageKeysList = function() {
  return this.setPageKeysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse;
  return proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.tutorial_videos.v1.TutorialVideo;
      reader.readMessage(value,proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter
    );
  }
};


/**
 * optional TutorialVideo data = 1;
 * @return {?proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.tutorial_videos.v1.TutorialVideo} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.tutorial_videos.v1.TutorialVideo, 1));
};


/**
 * @param {?proto.acompanha.tutorial_videos.v1.TutorialVideo|undefined} value
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse} returns this
*/
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse} returns this
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
section: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderedUuidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest;
  return proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrderedUuids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderedUuidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string section = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string ordered_uuids = 2;
 * @return {!Array<string>}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.getOrderedUuidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.setOrderedUuidsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.addOrderedUuids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest.prototype.clearOrderedUuidsList = function() {
  return this.setOrderedUuidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.tutorial_videos.v1.TutorialVideo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse;
  return proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.tutorial_videos.v1.TutorialVideo;
      reader.readMessage(value,proto.acompanha.tutorial_videos.v1.TutorialVideo.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.tutorial_videos.v1.TutorialVideo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TutorialVideo items = 1;
 * @return {!Array<!proto.acompanha.tutorial_videos.v1.TutorialVideo>}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.tutorial_videos.v1.TutorialVideo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.tutorial_videos.v1.TutorialVideo, 1));
};


/**
 * @param {!Array<!proto.acompanha.tutorial_videos.v1.TutorialVideo>} value
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse} returns this
*/
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.TutorialVideo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.tutorial_videos.v1.TutorialVideo}
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.tutorial_videos.v1.TutorialVideo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse} returns this
 */
proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest;
  return proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest}
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} returns this
 */
proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.tutorial_videos.v1);
